module.exports = __webpack_public_path__ + "img/logo-text.b6f8a905.svg";